import { render, staticRenderFns } from "./ExpertProfile.vue?vue&type=template&id=1c0e697a&scoped=true"
import script from "./ExpertProfile.vue?vue&type=script&lang=js"
export * from "./ExpertProfile.vue?vue&type=script&lang=js"
import style0 from "./ExpertProfile.vue?vue&type=style&index=0&id=1c0e697a&prod&lang=scss&scoped=true"
import style1 from "./ExpertProfile.vue?vue&type=style&index=1&id=1c0e697a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0e697a",
  null
  
)

export default component.exports